import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { PawPrint } from "lucide-react";

const POLICY_POINTS = [
  "Long Island has a leash law — pets must be kept on a leash at all times when outdoors.",
  "Pets are not permitted on any furniture, beds, or linens.",
  "Waste pickup bags are provided at the inn, and a pooper-scooper is available for the yard.",
  "Please clean up after your pet(s) promptly — both indoors and throughout the yard — during your stay and before checkout.",
  "A flat $150 pet fee applies per stay, and pets are limited to a maximum of two (2).",
];

export const PetPolicyDialog = ({ open, onOpenChange, onAccept }) => {
  const [agreed, setAgreed] = useState(false);

  const handleAccept = () => {
    if (!agreed) return;
    onAccept();
    setAgreed(false);
  };

  const handleOpenChange = (val) => {
    if (!val) setAgreed(false);
    onOpenChange(val);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-lg" data-testid="pet-policy-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-serif text-2xl text-[#134E4A]">
            <PawPrint className="h-6 w-6" />
            Pet Policy
          </DialogTitle>
          <DialogDescription className="text-[#78716C]">
            We happily welcome well-behaved pets. Please review and accept the following before adding a pet to your reservation.
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-3 my-2">
          {POLICY_POINTS.map((point, idx) => (
            <li key={idx} className="flex items-start gap-3 text-sm text-[#1C1917]">
              <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[#134E4A] shrink-0" />
              <span>{point}</span>
            </li>
          ))}
        </ul>

        <label
          htmlFor="pet-policy-agree"
          className="flex items-start gap-3 rounded-md border border-stone-200 bg-stone-50 p-3 cursor-pointer"
        >
          <Checkbox
            id="pet-policy-agree"
            checked={agreed}
            onCheckedChange={(c) => setAgreed(c === true)}
            className="mt-0.5"
            data-testid="pet-policy-agree-checkbox"
          />
          <span className="text-sm font-medium text-[#1C1917]">
            I have read, understood, and agree to abide by the Pet Policy above.
          </span>
        </label>

        <DialogFooter className="mt-2">
          <Button variant="outline" onClick={() => handleOpenChange(false)} data-testid="pet-policy-cancel">
            Cancel
          </Button>
          <Button
            onClick={handleAccept}
            disabled={!agreed}
            className="bg-[#134E4A] hover:bg-[#0f3d3a]"
            data-testid="pet-policy-accept"
          >
            Accept &amp; Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PetPolicyDialog;
